'use client';

import { type MotionProps, type Transition, type UseInViewOptions, type Variant, motion, useInView } from 'framer-motion';
import { type HTMLProps, type ReactNode, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

type CombinedProps = HTMLProps<HTMLDivElement> & MotionProps;
interface InViewProps extends CombinedProps {
	children: ReactNode;
	variants?: {
		hidden: Variant;
		visible: Variant;
	};
	transition?: Transition;
	viewOptions?: UseInViewOptions;
}

const defaultVariants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1 },
};

export default function InView({ children, variants = defaultVariants, className, transition, viewOptions, ...rest }: InViewProps) {
	const ref = useRef<HTMLDivElement>(null);

	const inView = useInView(ref, viewOptions);

	return (
		<motion.div
			ref={ref}
			initial="hidden"
			animate={inView ? 'visible' : 'hidden'}
			variants={variants}
			transition={transition}
			className={twMerge(className, 'p-0')}
			{...rest}
		>
			{children}
		</motion.div>
	);
}
